import classNames from 'classnames'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {BsCheckLg} from 'react-icons/bs'
import {GoDotFill} from "react-icons/go";

const STEPS = [
    {
        key: 'identity_review',
        label: 'identity review',
        desc: 'pipeline step 1 desc',
        statuses: [-1, 1],
    },
    {
        key: 'assign_class',
        label: 'ready for class',
        desc: 'pipeline step 3 desc',
        statuses: [2],
    },
    {
        key: 'completed',
        label: 'enrollment completed',
        desc: 'pipeline step 4 desc',
        statuses: [9],
    },
]

function getStepIndex(status) {
    return STEPS.findIndex(s => s.statuses.includes(status))
}

export const EnrollmentStepProgress = ({status}) => {
    const t = useTranslate()
    const currentIndex = getStepIndex(status)

    return (
        <div className="flex flex-col flex-1 gap-1">
            <div className="flex items-center">
                {STEPS.map((step, i) => {
                    const isDone = i < currentIndex
                    const isActive = i === currentIndex
                    const isLast = i === STEPS.length - 1
                    return (
                        <React.Fragment key={step.key}>
                            <div className="flex flex-col items-center gap-1 flex-shrink-0">
                                <div className={classNames(
                                    'w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all',
                                    isDone
                                        ? 'bg-green-500 border-green-500 text-white'
                                        : isActive
                                            ? 'bg-blue-500 border-blue-500 text-white'
                                            : 'bg-color-50 border-color-100 text-color-300'
                                )}>
                                    {isDone ? <BsCheckLg size={11}/> : i + 1}
                                </div>
                                <span className={classNames(
                                    'text-2xs font-medium leading-tight text-center whitespace-nowrap tracking-wider',
                                    isActive ? 'text-blue-500' : isDone ? 'text-green-600' : 'text-color-400'
                                )}>
                                    {t(step.label)}
                                </span>
                            </div>
                            {!isLast && (
                                <div style={{ height: 1 }} className={classNames(
                                    'flex-1 mx-1 mb-4',
                                    i < currentIndex ? 'bg-green-400' : 'background-200'
                                )}/>
                            )}
                        </React.Fragment>
                    )
                })}
            </div>
            {currentIndex >= 0 && (
                <span className="text-xs text-color-200 leading-snug italic tracking-wider">
                    <GoDotFill size={10} className="mr-1 text-color-500"/>
                    {t(STEPS[currentIndex]?.desc)}
                </span>
            )}
        </div>
    )
}
